function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 25 24"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12.491",
                cy: "11.98",
                r: "10.853",
                stroke: "#EEF",
                strokeWidth: "1.55"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.316 8.262c1.045 0 1.604-.613 1.604-1.496 0-.865-.559-1.513-1.604-1.513-1.027 0-1.603.648-1.603 1.513 0 .883.576 1.496 1.603 1.496Zm1.352 10.325V9.199h-2.703v9.388h2.703Z",
                fill: "#EEF"
            })
        ]
    }));
};
export default Icon;
